import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Debug logging
    if (!loading) {
      console.log('[AdminRoute] Auth state:', {
        hasUser: !!user,
        userId: user?.id,
        userPhone: user?.phone,
        pathname: location.pathname
      });
    }
  }, [user, loading, location.pathname]);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div style={{ fontSize: '1.2rem' }}>Загрузка...</div>
      </div>
    );
  }

  // If user is not authenticated, redirect to home
  // Admin check will be done on backend - if user is not admin, 
  // backend will return 403 and AdminDashboard will show error
  if (!user) {
    console.log('[AdminRoute] User not authenticated, redirecting to /');
    return <Navigate to="/" replace />;
  }

  console.log('[AdminRoute] User authenticated, rendering admin dashboard');
  return children;
};

export default AdminRoute;

